"use strict";
var __importDefault = (this && this.__importDefault) || function (mod) {
    return (mod && mod.__esModule) ? mod : { "default": mod };
};
Object.defineProperty(exports, "__esModule", { value: true });
exports.BannerImage = void 0;
const jsx_runtime_1 = require("react/jsx-runtime");
const react_1 = require("react");
const shell_banner_full_webp_1 = __importDefault(require("../images/shell-banner-full.webp"));
const shell_banner_half_night_webp_1 = __importDefault(require("../images/shell-banner-half-night.webp"));
const shell_banner_full_night_webp_1 = __importDefault(require("../images/shell-banner-full-night.webp"));
const shell_banner_half_webp_1 = __importDefault(require("../images/shell-banner-half.webp"));
const react_next_1 = require("@geome/react-next");
const BannerImage = ({ className, siteStatus }) => {
    const divClassName = (0, react_next_1.useBEM)({
        block: "location-page",
        element: "header-banner-image",
        modifiers: {
            "is-closed": siteStatus !== undefined && siteStatus !== "Active",
        },
    });
    const darkMode = (0, react_next_1.useMatchMedia)("(prefers-color-scheme: dark)");
    const [halfImage, fullImage] = (0, react_1.useMemo)(() => {
        return darkMode
            ? [shell_banner_half_night_webp_1.default, shell_banner_full_night_webp_1.default]
            : [shell_banner_half_webp_1.default, shell_banner_full_webp_1.default];
    }, [darkMode]);
    return ((0, jsx_runtime_1.jsx)("div", { className: divClassName, children: (0, jsx_runtime_1.jsxs)("picture", { children: [(0, jsx_runtime_1.jsx)("source", { media: "(max-width: 700px)", src: halfImage }), (0, jsx_runtime_1.jsx)("source", { src: fullImage }), (0, jsx_runtime_1.jsx)("img", { className: className, "aria-hidden": "true", role: "presentation", src: fullImage, alt: "" })] }) }));
};
exports.BannerImage = BannerImage;
